export const AUTH_CONTAINER_CLASS = "w-full";

export const AUTH_FORM_CLASS = "grid gap-6";

export const AUTH_HEADER_CLASS = "grid gap-2 text-left";
export const AUTH_TITLE_CLASS = "text-lg font-bold leading-tight tracking-tight text-foreground sm:text-xl";
export const AUTH_SUBTITLE_CLASS = "text-sm leading-relaxed";

export const AUTH_FIELDS_CLASS = "grid gap-4 text-sm sm:gap-5";

export const AUTH_ACTIONS_CLASS = "py-2";

export const AUTH_FIELD_ITEM_CLASS = "relative grid gap-1 space-y-0";
export const AUTH_FLOATING_LABEL_CLASS = "absolute left-4 top-2 z-10 text-[11px] font-semibold leading-none text-foreground";
export const AUTH_INPUT_CLASS =
  "h-14 rounded-xl border border-border bg-muted px-4 pt-7 appearance-none placeholder:text-muted-foreground";

export const AUTH_LINKS_ROW_CLASS = "mt-2 flex flex-wrap gap-x-6 gap-y-1 text-left text-sm text-foreground";
export const AUTH_LINK_CLASS = "underline underline-offset-4 hover:text-foreground/80";
